import React from "react";
import Slider from "react-slick";
import CharchaCard from "./CharchaCard";
import ReelCard from "../../Empowering/emp_components/ReelCard";
import data from "../../common/ShareText.json";

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/images/rightarrow2.svg" className="" alt="" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/images/leftarrow2.svg" className="" alt="" />
    </div>
  );
}

const CharchaShortSlider = ({
  shortsData,
  handleclick,
  isEpisode,
  isShortReel,
  handleShareData,
  type,
  sharetext,
}) => {
  var settings = {
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    dots: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      <div className="reel_slider">
        <Slider {...settings}>
          {shortsData?.map((reel, index) => (
            <div key={index}>
              {reel && (
                <ReelCard
                  reel={reel}
                  handleclick={handleclick}
                  isShort={true}
                  isEpisode={isEpisode}
                  isShortReel={isShortReel}
                  handleShareData={handleShareData}
                  shortsData={shortsData}
                  shareText={sharetext}
                  index={index}
                  indexforslide={index}
                  type={type}
                />
              )}
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default CharchaShortSlider;
